export default "__VITE_ASSET__DvS9JZ8G__"